/** Browser/Vite download errors only; application errors must not be retried. */
export function isModuleLoadError(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk [\w-]+ failed|Unable to preload CSS/i.test(
    message
  )
}

export async function importWithRetry<T>(loader: () => Promise<T>): Promise<T> {
  try {
    return await loader()
  } catch (error) {
    if (!isModuleLoadError(error) || navigator.onLine === false) throw error
    // A single retry helps transient failures. Missing deployment assets require a new document.
    await new Promise((resolve) => setTimeout(resolve, 350))
    return loader()
  }
}
